<!-- 進站聲明稿：enabled 為 false 時不輸出 -->
<div id="statementDialog" *ngIf="enabled">
	<!-- SSR / prerender：首頁輸出靜態版聲明全文供搜尋引擎索引，瀏覽器啟動後由下方彈窗取代 -->
	<div *ngIf="isServer && isHome" class="statement-ssr">
		<div class="statement-ssr-panel statement-dialog">
			<div class="statement-ssr-header">【坤侑科技聲明稿】</div>
			<div class="statement-ssr-content">
				<ng-container *ngTemplateOutlet="statementContent"></ng-container>
			</div>
		</div>
	</div>

	<p-dialog
		header="【坤侑科技聲明稿】"
		[(visible)]="visible"
		[style]="{ width: '94vw', 'max-width': '720px' }"
		[contentStyle]="{ paddingBottom: '1.5rem' }"
		[modal]="true"
		[dismissableMask]="false"
		[closeOnEscape]="false"
		[draggable]="false"
		[closable]="true"
		closeAriaLabel="關閉聲明"
		[showHeader]="true"
		[baseZIndex]="1200"
		styleClass="statement-dialog"
		(onHide)="close()"
	>
		<ng-template pTemplate="content">
			<ng-container *ngTemplateOutlet="statementContent"></ng-container>
		</ng-template>
	</p-dialog>

	<ng-template #statementContent>
		<article class="statement-body">
			<h2 class="statement-title">
				【坤侑科技聲明稿】針對「外交部資訊資產管理軟體事件」之說明
			</h2>
			<p>
				對於近日媒體報導關於「外交部資訊資產管理軟體事件」，為消除各機關的疑慮，坤侑科技股份有限公司（以下簡稱本公司）特此針對本案提出四點說明：
			</p>
			<h3>一、本案角色：銷售與整合端</h3>
			<p>
				本案中依據機關需求，本公司僅負責系統整合，協助採購並交付這套軟體，非該軟體的原始開發商。
			</p>
			<h3>二、嚴格查核：堅守非陸製底線</h3>
			<p>
				政府機關資安的嚴格要求，「絕不使用陸資或陸製產品」的原則底線，本公司亦取得原廠本案佐證文件並交付機關，由於原廠產品程式碼屬於商業機密不能隨意拆解檢查，同時已將相關佐證資料交給司法單位與機關，全力配合調查。
			</p>
			<h3>三、爭議原廠產品僅單一交付，將主動提供資安報告</h3>
			<p>
				引發此爭議的原廠產品，本公司多年專案中，僅於此單一專案合作交付外交部，對於本公司有合作之其他政府機關與企業客戶，將進一步於三個工作日內，主動提供專案與自行研發的系統產品之第三方資安檢測報告，以確認安全無虞，並保障其權益不受影響。
			</p>
			<h3>四、即日起停止與涉案廠商合作</h3>
			<p>
				對於涉案廠商隱瞞軟體技術來源，導致引發資安疑慮並嚴重損害機關信譽與本公司商譽，感到十分遺憾與憤怒。即日起已全面停止與該涉案廠商的所有合作，同時委請律師，針對涉案廠商隱瞞事實所造成的損失依法評估提出告訴，捍衛本公司的清白與權益。
			</p>
			<p>
				本公司深耕資訊系統多年，對於本次事件引發各界疑慮深表遺憾。資通安全攸關國家安全，身為長期服務公部門的資訊廠商，恪守系統安全與公眾信任是我們的責任，同時將全面強化供應商審查與產品源頭稽核機制，杜絕類似情事再次發生。未來，本公司亦將全力配合司法調查，以具體行動回應社會期待。
			</p>
			<p class="statement-sign">
				特此聲明<br />
				坤侑科技股份有限公司 敬上
			</p>
			<p class="statement-lawyer">
				<span>環群商務法律事務所 龔新傑律師</span>
				<img
					class="statement-seal"
					src="assets/images/statement/lawyer-seal.png"
					alt="龔新傑律師印章"
				/>
			</p>
		</article>
	</ng-template>
</div>
